/*
semsomi AB
Copyright (c) 2016-2017
All rights reserved
*/

"use strict";

import "babel-polyfill";

import ReactDOM from 'react-dom';
import React from 'react';
import { Provider } from 'react-redux';
import store from './store';
import T from 'i18n-react';
import appComponent from'./components/app.jsx';
import { Router, Route, Link, browserHistory, hashHistory } from 'react-router'
import {StripeProvider} from 'react-stripe-elements';


// import '../css/1.bootstrap.min.css';
import '../css/app.css';
// import '../css/font-awesome.min.css';
import '../css/google-font-open-sans-lora.css';
import '../css/google-font-pt-sans-narrow.css';
// import '../css/tagify.css';
// import '../editor/blockquote-editor.js';

var p = console.log

String.prototype.hashCode = function() {
  var hash = 0, i, chr;
  if (this.length === 0) return hash;
  for (i = 0; i < this.length; i++) {
    chr   = this.charCodeAt(i);
    hash  = ((hash << 5) - hash) + chr;
    hash |= 0; // Convert to 32bit integer
  }
  return hash;
};

// convert a Unicode string to a string in which
// each 16-bit unit occupies only one byte
String.prototype.encode = function() {
  const codeUnits = new Uint16Array(this.length);
  for (let i = 0; i < codeUnits.length; i++) {
    codeUnits[i] = this.charCodeAt(i);
  }
  return btoa(String.fromCharCode(...new Uint8Array(codeUnits.buffer)));
}

String.prototype.decode = function() {
  let binary = atob(this)
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < bytes.length; i++) {
    bytes[i] = binary.charCodeAt(i);
  }
  return String.fromCharCode(...new Uint16Array(bytes.buffer));
}
// p("last commit:\n" + process.env.LAST_COMMIT);

//To disable all console log in prod
// console.log = function() {}

var config = require('../settings/config.json');
window.env = process.env.NODE_ENV
var app = document.getElementById('container');

//###### GOOGLE ANALYTICS ######
var ReactGA = require('react-ga')
if(window.env === 'production'){
	ReactGA.initialize(config.analytics.id)
}
//##############################
window.monokSess = Math.random()
window.entrypointMonok = window.location.href
// console.log(window.entrypointMonok)

function logPageView() {
  if(window.env === 'production'){
  	ReactGA.set({page: window.location.pathname});
	  ReactGA.pageview(window.location.pathname);
  }
}

ReactDOM.render(
      <Provider store={store} >
        	<Router history={browserHistory} onUpdate={logPageView}>
              <Route path="/" component={appComponent}>
              <Route path="/*" component={appComponent}/>
        	    <Route path="/*/:userName" component={appComponent}/>
       		</Route>
        	</Router>
        </Provider>
, app);







